module.exports = __webpack_public_path__ + "static/media/input-cursor-text.c5cc4fb9.svg";